module.exports = __webpack_public_path__ + "static/media/lance-coury-loop-2.d78c76ee.mp4";